<template>
  <div class="rodemap">
    <div class="mask05"></div>
    <QuestionSelect :data="data" @jump="jump" @finish="finish"></QuestionSelect>
  </div>
</template>

<script>
//script
import Tools from "../../../scripts/tools";
import { gsap } from "gsap";
//Global
import Global from "../../../scripts/Global";

import QuestionSelect from "../../cmp/questionSelect";

export default {
  data() {
    return {
      data: {
        // headTipImg: '乔诗语讲解',
        headTipTxt:
          "这是金象啦，仔细观察它的造型，它的前肢方向是向前的（负跪），寓意 “富贵吉祥”",
        headTipPathTxt: "前往延晖阁 >>",
        headTipPath: "/rodemap/qsy/05",

        qImg: "乔诗语-吉象",
        qText: "快来看，这个铜像好可爱！你知道它是什么动物吗？",
        errText: "快来看，马上要选秀女了！你知道怎样算是选中了吗？",
        okText: "快来看，马上要选秀女了！你知道怎样算是选中了吗？",

        headTipStyle: {
          bottom: "-1rem"
        },

        answerArr: [
          {
            txt: "仙 鹤"
          },
          {
            txt: "麒 麟"
          },
          {
            txt: "金 象",
            right: true
          }
        ]
      }
    };
  },
  components: {
    QuestionSelect
  },
  created() {
    Global.startPlay("qsy", "scene6");
  },
  computed: {},
  methods: {
    jump(event) {
      if (event) {
      } else {
        this.$router.replace("/rodemap/qsy/05");
      }
      console.log(event, "event");
    },
    finish(event) {
      if (event) {
        Global.curr = {
          ...this.data,
          headTipImg: "",
          headTipTxt: "",
          headTipPath: "/rodemap/qsy/05",
          headTipPathTxt: "前往延晖阁 >>",
          ybtxt:
            "没错，就是象。仔细观察它的造型，它的前肢方向是向前的（负跪），寓意“富贵吉祥”（负跪吉象），走，拿上奖励，去里面看看。",
          bg: "琼苑东门"
        };
        Global.yubi.qsy.b2 = true;
        this.$router.replace("/yu");
        Global.startPlay("qsy", "scene8");
      } else {
        Global.startPlay("qsy", "scene7");
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.head-tip-man {
  .txt {
    margin: 0 0.5rem 0 0.5rem !important;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/承光门.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
